import { Services } from '@sigma-frontend-libs/commons'
import { REGEXP_SENDERNAME_SMS, REGEXP_SENDERNAME_VOICE } from '@sigma-legacy-libs/essentials/lib/constants'
import { SendingTypes } from '@sigmasms/shared-types'

import { permissionPresets, proxy } from '@/utils'

import render from './render'

export default {
  name: 'Form',

  mixins: [ proxy({ type: 'object' }) ],

  props: {
    errors: {
      type: Object,
      default: () => {
        return {}
      }
    },

    isNew: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    canCreateSendernames() {
      return this.checkPermissions(`advanced.${Services.sendernames}.create`, permissionPresets.me)
    },

    canCreateSendernamesAsMeOrReseller() {
      return this.checkPermissions(`advanced.${Services.sendernames}.create`, [ permissionPresets.me, permissionPresets.reseller ])
    },

    canCreateSendernamesAsReseller() {
      return this.checkPermissions(`advanced.${Services.sendernames}.create`, permissionPresets.reseller)
    },

    canCreateSendernamesAsAdmin() {
      return this.checkPermissions(`advanced.${Services.sendernames}.create`)
    },

    canCreateSendernamesAsResellerUp() {
      return this.checkPermissions(`advanced.${Services.sendernames}.create`, permissionPresets.resellerUp)
    },

    canUpdateSendernamesAsAdmin() {
      return this.checkPermissions(`advanced.${Services.sendernames}.update`)
    },

    canUpdateSendernamesAsResellerUp() {
      return this.checkPermissions(`advanced.${Services.sendernames}.update`, permissionPresets.resellerUp)
    },

    canGetRequisitesAsResellerUp() {
      return this.checkPermissions(`advanced.${Services.requisites}.get`, permissionPresets.resellerUp)
    },

    canGetSendernames() {
      return this.checkPermissions(`advanced.${Services.sendernames}.get`, [ 'me', false ])
    },

    senderNameIsValid() {
      if (this.proxy.name) {
        switch (this.proxy.type) {
          case SendingTypes.sms: return REGEXP_SENDERNAME_SMS.test(this.proxy.name)
          case SendingTypes.voice: return REGEXP_SENDERNAME_VOICE.test(this.proxy.name)
        }

        return true
      }

      return false
    },

    senderNameMask() {
      if (this.isNew) {
        switch (this.proxy.type) {
          case SendingTypes.sms: return /^[a-zA-Z0-9!?\-_.()]{0,11}$/
          case SendingTypes.voice: return /^\d{0,15}$/
        }
      }
    },

    validation() {
      let checkComment = false
      if (this.canCreateSendernames) {
        checkComment = /^.{10,150}$/.test(this.proxy.meta.comment)
      } else {
        checkComment = true
      }

      return this.senderNameIsValid && checkComment
    }
  },

  watch: {
    'proxy.type'() {
      this.proxy.name = undefined
    },
    validation() {
      this.$emit('validation', this.validation)
    }
  },

  mounted() {
    this.$emit('validation', this.validation)
  },

  render
}
